import { getDataPng } from "./getDataPng";
import type { UrlsDataType } from "../types/lib/useGetTileUrls";
import { MapGeoJSONFeature } from "maplibre-gl";
import { replaceStrArr } from "./formatedText";
import { LAYER_GEOMETRY_TYPES } from "./smartCityStyle";
import { DataType } from "../types/lib/types";
import { fiwareDataItemType } from "../types";


export const ALERT_TILE_ID = 'yaizu-alert-area';
export const ALERT_TILE_URL = 'https://de2kj1j7vldyl.cloudfront.net/sandbox/yaizu-alert-area.pmtiles';
export const ALERT_TILE_SOURCE_LAYER = 'main';

export const getFeatureArrData = async (
    map: maplibregl.Map | undefined,
    clickEvent: maplibregl.MapMouseEvent | undefined,
    menuItems: DataType[] | undefined,
    dataPngUrls: UrlsDataType[],
    vectorTileUrls: UrlsDataType[]
): Promise<{ [key: string]: maplibregl.MapGeoJSONFeature[] } | undefined> => {

    if (!map) { return undefined; }

    let features: MapGeoJSONFeature[];

    const lngLat = clickEvent ? clickEvent.lngLat : map.getCenter();

    const BUFFER = 1; // バッファのサイズ（ピクセル単位）

    if (clickEvent){
        const point = clickEvent.point;
        // ポイントの周囲にバッファを追加して矩形領域を定義
        const bbox = [
            [point.x - BUFFER, point.y - BUFFER], // 左上
            [point.x + BUFFER, point.y + BUFFER]  // 右下
        ] as [maplibregl.PointLike, maplibregl.PointLike];
    
        features = map.queryRenderedFeatures(bbox);
    } else {
        features = map.queryRenderedFeatures();
    }

    const featureArr: { [key: string]: maplibregl.MapGeoJSONFeature[] } = {};
    const vectorTileIds = vectorTileUrls.map((item) => item.tileId);

    // データPNGの属性の取得
    const layers = map.getStyle().layers;
    const dataPngLayers = layers.filter((layer: maplibregl.LayerSpecification): layer is maplibregl.RasterLayerSpecification => {
        if (layer.type !== 'raster') { return false; }
        if (layer.layout && layer.layout.visibility === 'none') { return false; } // visibilityがnoneのときはreturn
        return dataPngUrls.some((item) => item.tileId === layer.source);
    });

    // ① データPNGの場合
    if (dataPngLayers.length > 0) {
        for (const dataPngLayer of dataPngLayers) {
        // クリック箇所のデータを取得
        const data = await getDataPng(lngLat.lat, lngLat.lng, Math.trunc(18), dataPngLayer.source, dataPngUrls);
    
        if (data?.value && data?.description) {
            const attribute = {
            [data.description]: data ? data.value.title : '取得できません',
            };

            // データ詳細パネルで表示するラベルを取得
            const catalogNameArr = dataPngLayer.id.split('/');
            const catalogName = catalogNameArr[catalogNameArr.length - 1];

            featureArr[catalogName] = [{
            layer: {
                id: dataPngLayer.id,
                source: dataPngLayer.source,
                properties: { ...attribute }
            },
            properties: { ...attribute }
            } as unknown as maplibregl.MapGeoJSONFeature];
        }
        }
    }
    
    // クリック箇所のデータを取得
    const filteredFeatures = features.filter((feature) =>
        (
            feature.source === ALERT_TILE_ID || 
            menuItems?.find((catalog) => (catalog.dataType === "fiware" && (catalog as unknown as fiwareDataItemType).dataId === feature.source) || catalog.tileId === feature.source) || 
            vectorTileIds.includes(feature.source)
        )
    );

    // ベクトルタイルのフィーチャーとデータPNGのフィーチャーがない場合
    if (filteredFeatures.length === 0 && Object.keys(featureArr).length === 0) { return undefined; }

    // let findPointData = false;
    
    // データ分繰り返す
    for (const feature of filteredFeatures) {

        // if(findPointData && (feature.layer.id.includes('Point') || feature.layer.id.includes('Symbol'))) {
        //     continue;
        // }

        // if(feature.layer.id.includes('Point') || feature.layer.id.includes('Symbol')) {
        //     findPointData = true;
        // }

        const catalogNameArr = feature.layer.id.split('/');
        const catalogName = replaceStrArr(catalogNameArr[catalogNameArr.length - 1], [...Object.values(LAYER_GEOMETRY_TYPES), '-'], '');

        if (catalogName in featureArr) {
            featureArr[catalogName] = [...featureArr[catalogName], feature];
        } else {
            featureArr[catalogName] = [feature];
        }
    };

    return featureArr;
};
